/**
 * Quick refactoring of the video controls to make it easier to read and maintain.
 * Open for further refactoring/improvements.
 * TODO: remove the use of the global event bus
 */
import { computed } from 'vue'
import { type Behavior } from '@source-digital/experience-core'
import { Platform } from '@source-digital/experience-utils'

function getOverlayPlayButton ($behavior: Behavior) {
  if ($behavior.exists('hideOverlayPlayButton')) return ''
  return '<button type="button" class="plyr__control plyr__control--overlaid" data-plyr="play" aria-label="Play"><svg role="presentation" focusable="false"><use xlink:href="#plyr-play"></use></svg><span class="plyr__sr-only">Play</span></button>'
}

function getPlayButton () {
  if (Platform.is.mobile === true) return ''
  return `<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play">
  <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg>
  <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg>
</button>`
}
function getVolumeButton ($behavior: Behavior) {
  if ($behavior.exists('hideVolume')) return ''
  return `<div data-plyr="mute" class="plyr__controls__item plyr__volume sdVolumeBtnContainer">
  <button type="button" class="plyr__control sdVolumeBtn" data-plyr="mute"><svg class="icon--pressed" aria-hidden="true" focusable="false"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" aria-hidden="true" focusable="false"><use xlink:href="#plyr-volume"></use></svg></button>
</div>`
}
function getVolumeSlider ($behavior: Behavior) {
  if ($behavior.exists('hideVolume')) return ''
  if (Platform.is.mobile === true) return '<div style="width:10px;"></div>'
  return '<div class=\'plyr__controls__item plyr__volume sdVolumeRange\'><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"> </div>'
}
function getProgressBar ($behavior: Behavior) {
  if ($behavior.exists('hideProgressBar')) return ''
  return `<div class="plyr__controls__item plyr__progress__container">
                <div class="plyr__progress">
                  <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek" ${$behavior.exists('preventSeek') ? 'disabled' : ''}>
                  <progress class="plyr__progress__buffer" min="0" max="100" value="0" role="progressbar" aria-hidden="true">% buffered</progress>
                  <span role="tooltip" class="plyr__tooltip">00:00</span>
                </div>
              </div>`
}
const currentTimeUi = '<div class="plyr__controls__item plyr__time--current plyr__time" aria-label="Current time">00:00</div>'
const captionsUi = `<button type="button" class="plyr__controls__item plyr__control" data-plyr="captions">
<svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-captions-on"></use></svg>
<svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-captions-off"></use></svg>
</button>`

function getFullscreenUi ($behavior: Behavior, isInteractive?: boolean) {
  if ($behavior.exists('hideFullscreen') || isInteractive === true) return ''
  return `<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen">
                  <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg>
                  <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg>
                </button>`
}

export function usePlyrVideoControls ($behavior: Behavior) {
  const controls = computed(() => {
    if ($behavior.exists('hideControls')) return null
    const uiHtml = `
            ${getOverlayPlayButton($behavior)}
            <div class="plyr__controls">
                ${getPlayButton()}
                ${getVolumeButton($behavior)}
                ${getVolumeSlider($behavior)}
                ${getProgressBar($behavior)}
                ${currentTimeUi}
                ${captionsUi}
                ${getFullscreenUi($behavior)}
            </div>
            `
    return uiHtml
  })
  return {
    controls
  }
}
